export default {
      id: "playback__video-event-3-usage",
      viewBox: "0 0 28 27",
      url: __webpack_public_path__ + "img/icons.svg#playback__video-event-3",
      toString: function () {
        return this.url;
      }
    }